module.exports = __webpack_public_path__ + "img/15.34e35b40.png";